export const countRowsFile = (file: File ) : number => {
    const reader = new FileReader();
    let rowCount = 0;
    reader.onload = async (e) => {

        const text = e.target?.result as string;
        const lines = text.split(/\r\n|\n|\r/);
        rowCount = lines.filter(line => line.trim() !== '').length;

    };
    reader.readAsText(file);

    return rowCount;
};

export const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
            const result = reader.result as string;
            
            const base64Content = result.split(',')[1]; 
            resolve(base64Content);
        };
        reader.onerror = (error) => reject(error);
        reader.readAsDataURL(file);
    });
};

export const getFileData = (file: File) => {
    const fileName = file.name;    
    const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();
    const mimeType = file.type;

    return { extension, mimeType };
};

export const downloadBase64File = (fileName: string, base64Data: string, contentType = "application/octet-stream") => {
    const rawBase64 = base64Data.startsWith("data:") ? base64Data.split(",")[1] : base64Data;

    const byteString = atob(rawBase64);
    const bytes = new Uint8Array(byteString.length);
    for (let i = 0; i < byteString.length; i++) {
        bytes[i] = byteString.charCodeAt(i);
    }

    const url = URL.createObjectURL(new Blob([bytes], { type: contentType }));
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(url);
};

export const getContentTypeFromExtension = (ext?: string | null) => {
    switch (ext?.toLowerCase()) {
        case "pdf":  return "application/pdf";
        case "png":  return "image/png";
        case "jpg":
        case "jpeg": return "image/jpeg";
        case "txt":  return "text/plain";
        default:     return undefined;
    }
};